import React from 'react';

import { MetadataDrivenSiteSettings } from '~commonInfra/components/MetadataDrivenSiteSetting';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { Messages } from '~src/codegen/Localize';

import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { useUserVisibilityLimited } from '../user-visibility/UserVisibilitySection';

export const SECTION_NAME = 'requestAccessForAIEnabled';
export const SECTION_FORMIK_PREFIX = 'settings';
export const SECTION_TEST_ID = 'requestAccessForAIEnabled-setting-section';

export function RequestAccessForAISettingSection(): React.ReactElement | null {
  const isUserVisibilityLimited = useUserVisibilityLimited();
  if (FeatureFlags.requestAccessForAIEnabled && FeatureFlags.metadataDrivenSiteSettingsEnabled && !isUserVisibilityLimited) {
    return (
      <SettingsSection
        title={Messages.requestAccessForAIEnabledSettingTitle()}
        testId={SECTION_TEST_ID}>
        <MetadataDrivenSiteSettings
          sectionName={SECTION_NAME}
          formikPrefix={SECTION_FORMIK_PREFIX} />
      </SettingsSection>
    );
  }

  return null;
}

export const RequestAccessForAISettingSectionSpecs = componentRegistryEntry({
  name: 'RequestAccessForAISettingSection',
  component: RequestAccessForAISettingSection
});
